import React from "react";

import Header from "./../../components/Header/";
import Footer from "./../../components/Footer/";

import ScheduleProcessComponent from "./../../components/ScheduleProcessComponent/";

import {
  Container,
  Content,
  ScheduleProcessComponentContainer,
} from "./styles";

import { useAuth } from "../../hooks/auth";
import { useRefresh } from "../../hooks/refresh";
import { useEffect, useState } from "react";
import api from "../../services/api";
import Loading from "../../components/Loading";

interface IApiResult {
  id: number;
  status: string;
  property_id: number;
  title: string;
  rent_value: string;
  condominium_value: string;
  iptu_value: string;
  address: string;
  neighborhood: string;
  city: string;
  uf: string;
  photo: string;
}

export default function ScheduleProcess() {
  const { user, access_token } = useAuth();
  const { refresh } = useRefresh();

  const [apiResult, setApiResult] = useState<IApiResult[]>([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadApi() {
      if (!user) {
        return;
      }

      setLoading(true);
      api.defaults.headers.authorization = `Bearer ${access_token}`;

      try {
        const responseApiVisits = await api.get(
          "/api/client/tenant/rent-process"
        );

        setApiResult(responseApiVisits.data.data);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    }

    loadApi();
  }, [access_token, user, refresh]);

  if (!!loading) return <Loading />;

  return (
    <Container>
      <Header hasBorder hasSearchBar />
      <Content>
        <h3>INQUILINO</h3>
        <h1>Acompanhamento</h1>

        <ScheduleProcessComponentContainer>
          {apiResult.map((rentInformation) => {
            return (
              <ScheduleProcessComponent rentInformation={rentInformation} />
            );
          })}
        </ScheduleProcessComponentContainer>
      </Content>
      <Footer />
    </Container>
  );
}
